import injectIntl from "../../../../../../../common/helpers/injectIntl";

import ScoreEditor from "./ScoreEditor";

export default injectIntl(ScoreEditor);
